import { Field, Label, Description, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";
import { Textarea } from "V2.0/common/textarea";

import PayloadMapping from "./PayloadMapping";

export default WebhookTriggerConfigForm;

function WebhookTriggerConfigForm(props) {
  const { formState, updateFormState, errors, assistants, workspaceId } = props;

  return (
    <div className="flex flex-col gap-y-8">
      <Field>
        <Label>Name *</Label>
        <Input
          type="text"
          value={formState.name}
          onChange={(e) => updateFormState("name", e.target.value)}
          invalid={!!errors.name}
        />
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Description</Label>
        <Textarea
          value={formState.description}
          rows={3}
          onChange={(e) => updateFormState("description", e.target.value)}
        />
      </Field>

      <div>
        <PayloadMapping
          payloadMapping={formState.payloadMapping}
          onUpdatePayloadMapping={(data) =>
            updateFormState("payloadMapping", data)
          }
          assistants={assistants}
          workspaceId={workspaceId}
        />
        {errors.payloadMapping && (
          <ErrorMessage>{errors.payloadMapping}</ErrorMessage>
        )}
      </div>
    </div>
  );
}
